<template>
  <div class="mb-4">
    <b-row class="mt-2 mb-1">
      <b-col>
        <h2>
          Who are <span class="dbb-red">we?</span> 
        </h2>
      </b-col>
    </b-row>

    <b-row class="my-1">
      <b-col>
        <p>
          The Wellcome Centre for <span class="dbb-red">Integrative Neuroimaging</span> is a multidisciplinary neuroimaging research facility based at the University of Oxford. Two major themes of our research are cross-species and cross-scale neuroimaging. Discover more about our centre <b-link class="dbb-red" href="https://www.win.ox.ac.uk/" >here</b-link>, and our research themes <b-link class="dbb-red" href="https://www.win.ox.ac.uk/about/themes" >here</b-link>. 
        </p>
      </b-col>
    </b-row>


    <b-row class="mt-2 mb-1">
      <b-col>
        <h2>
          What is the Digital <span class="dbb-red">Brain Bank?</span> 
        </h2>
      </b-col>
    </b-row>

    <b-row class="my-1">
      <b-col>
        <p>Post-mortem MRI provides the opportunity to validate the origins of image contrast through comparisons with microscopy, and acquire high-resolution datasets to investigate structural & comparative anatomy.</p>
        <p>
          Amongst many research avenues at the WIN, post-mortem brain imaging has become a considerable component of our work with cross-scale and cross-species neuroimaging. This has led to the acquisition of:
        </p>

        <p>
          <ul>
            <li>High-resolution multi-modal (i.e. MRI and microscopy) post-mortem datasets obtained from the same brain, to facilitate the examination of neuroanatomy.</li>
            <li>Multi-modal datasets from brains donated by people who have passed away after diagnosis of a neurological disease during their lifetime, to facilitate the examination of human neuropathology & MRI-pathology correlates.</li>
            <li>Post-mortem imaging in multiple species (e.g. non-human primates and beyond).</li>
          </ul>
        </p>

        <p>
          On this website, we have split this data under three themes, the Digital <b-link class="dbb-red" href="#/datasets/anatomist" >Anatomist</b-link>, the Digital <b-link class="dbb-red" href="#/datasets/pathologist">Pathologist</b-link>, and the Digital <b-link class="dbb-red" href="#/datasets/zoo" >Brain Zoo</b-link>. These unique datasets provide multiple avenues of research. Here, we invite you to explore and download the data available on the Digital <b-link class="dbb-red" href="#/">Brain Bank</b-link> to identify and answer your own research questions. 
        </p>
      </b-col>
    </b-row>


    <b-row class="mt-2 mb-1">
      <b-col>
        <h2>
          What is <span class="dbb-red">Tview?</span> 
        </h2>
      </b-col>
    </b-row>

    <b-row class="my-1">
      <b-col>
        <p>
          <i>Tview</i> is an open access visualisation platform designed to show high resolution microscopy and (comparatively) low resolution MRI in one viewer. It is built using <b-link class="dbb-red" href="https://leafletjs.com/">leafletjs</b-link> and uses <b-link class="dbb-red" href="https://libvips.github.io/libvips/">libvips</b-link> to generate tiles which enable efficient viewing across all device types.
        </p>

        <p>
          The Digital Brain Bank server, viewer, and website are open source. The code is available <b-link class="dbb-red" href="https://git.fmrib.ox.ac.uk/thanayik/slideviewer">here</b-link>
        </p>
      </b-col>
    </b-row>


    <b-row class="mt-2 mb-1">
      <b-col>
        <h2>
          Terms of <span class="dbb-red">Use</span> 
        </h2>
      </b-col>
    </b-row>

    <b-row class="my-1">
      <b-col>
        <p>
          The Digital <span class="dbb-red">Brain Bank</span> provides open access to post-mortem datasets. For datasets with specific restrictions (e.g. ethical, privacy, or funder restrictions), users will need to agree to certain conditions of use to access the full dataset. For these datasets, when possible dataset previews are available to freely download. Alternatively, a small subset of the available data can be visualised with the provided Viewer.  Agreement to conditions of use is currently achieved by contacting the relevant person (details provided in the Request Full Dataset link).  
        </p>

        <p>Users are asked to cite the original study for any given dataset and the Digital <span class="dbb-red">Brain Bank</span> for any resulting outputs (e.g. conference proceedings, publications etc.) which uses data from projects hosted here. Details of referencing are provided on the Information page associated with every dataset.</p>

      </b-col>
    </b-row>

    <b-row class="mt-2 mb-1">
      <b-col>
        <h2>
          Acknowledgements
        </h2>
      </b-col>
    </b-row>

    <b-row class="my-1">
      <b-col>
        <p>
         The Digital <span class="dbb-red">Brain Bank</span> is supported by a Wellcome Trust Senior Research Fellowship (202788/Z/16/Z) and a Medical Research Council grant (MR/K02213X/1). The Wellcome Centre for Integrative Neuroimaging is supported by core funding from the Wellcome Trust (203139/Z/16/Z).  
        </p>

      </b-col>
    </b-row>
  </div>
  
</template>

<script>
export default {
  name: "about"
  
}
</script>

<style scoped>
.dbb-red {
  color: #8b2a34;
}

</style>
